import { render, staticRenderFns } from "./ArticlesSick.vue?vue&type=template&id=a4a10530&scoped=true"
import script from "./ArticlesSick.vue?vue&type=script&lang=js"
export * from "./ArticlesSick.vue?vue&type=script&lang=js"
import style0 from "./ArticlesSick.vue?vue&type=style&index=0&id=a4a10530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a10530",
  null
  
)

export default component.exports